export var version = "3.9.8";
//# sourceMappingURL=version.js.map